<template>
  <v-card
    class="mx-auto"
    max-width="700"
  >

  <v-card-title>
     Subscribe to a plan
  </v-card-title>

  <v-card-text>

    <v-form
        
        ref="form"
    >     

        <v-text-field
        v-model="name"
        label="Full name"
        :rules="nameRules"
        required
        ></v-text-field>

    <v-select
      v-model="country"
      :items="countries"
      label="Country"
      @change="changeCountry"
      required
    ></v-select>
   
    <v-radio-group
        v-model="account_type"
        column
        @change="changeAccountType"
        >
        <v-radio
            label="Private Person"
            color="green"
            value="private"
        ></v-radio>
        <v-radio
            label="Company"
            color="green"
            value="company"
        ></v-radio>
    </v-radio-group>      

    <v-text-field
      v-if="vat_needed"
      v-model="vatid"
      label="VAT ID"
      required
      v-on:blur="checkVatId"
    ></v-text-field>
        <v-alert
      v-if="vat_needed && vat_error"
      dense
  elevation="2"
  outlined
  prominent
  text
  type="warning"
    >
    {{vat_error}}
    </v-alert>
       <v-alert
      v-if="vat_valid"
        dense
        elevation="2"
        outlined
        prominent
        text
        type="success"
    >
    {{vat_id_valid_text}}
    </v-alert>

    <v-text-field
      v-if="account_type=='company'"
      v-model="company"
      label="Company name"
      :rules="companyRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="email"
      label="Email"
      disabled
    ></v-text-field>

    <v-divider style="margin-top:30px;margin-bottom:30px;"></v-divider>

    <v-text-field
      v-model="address"
      label="Address"
      :rules="streetRules"
      required
    ></v-text-field>
   <v-row>
        <v-col
            cols="12"
            sm="6"
            md="6"
        >
        <v-text-field
        v-model="zip"
        label="Zip Code"
        :rules="zipRules"
        required
        ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            sm="6"
            md="6"
        >
        <v-text-field
        v-model="city"
        label="City"
        :rules="cityRules"
        required
        ></v-text-field>
        </v-col>
   </v-row>
  
    <v-divider style="margin-top:30px;margin-bottom:30px;">></v-divider>
    <div v-if="subdomain=='notism_test' || subdomain=='hotgloo_test' ">
        Test Card: 4242424242424242 | 4000002500003155
    </div>
    <div class="card-container" style="">

        <div
            class="focus:outline-none focus:bg-white;"
            id="card-element"
        ></div>

        <v-alert
        style="margin-top:30px;"
      v-if="card_error"
      dense
  elevation="2"
  outlined
  prominent
  text
  type="error"
      
    >
    {{card_error}}
    </v-alert>

    </div>
    <v-divider style="margin-top:30px;margin-bottom:30px;">></v-divider>
    <v-checkbox
      v-model="terms"
      :rules="[v => !!v || 'You must agree to continue!']"
      label="I agree to the terms & conditions"
      required
    ></v-checkbox>
    <div v-if="subdomain=='hotgloo' || subdomain=='hotgloo_test' ">
        Please check this box to confirm your agreement to the <a href="https://www.hotgloo.io/terms" target="_blank">terms and conditions</a>,  <a href="https://www.hotgloo.io/privacy" target="_blank">privacy policy</a> and <a href="https://www.hotgloo.io/refund" target="_blank">refund policies</a>.
    </div>
    <div v-if="subdomain=='notism' || subdomain=='notism_test'">
        Please check this box to confirm your agreement to the <a href="https://notism.io/terms" target="_blank">terms and conditions</a>,  <a href="https://notism.io/privacy" target="_blank">privacy policy</a> and <a href="https://notism.io/refund" target="_blank">refund policies</a>.
    </div>
 
    <div style="margin-top:30px;margin-bottom:30px;"></div>
    <v-btn
      v-show="!processing"
      color="success"
      elevation="7"
      rounded
      x-large
      @click="validate"
    >
     Subscribe
    </v-btn>

    <v-btn
      v-show="!processing"
      style="margin-left:30px;"
      text
      @click="cancel"
    >
     Cancel
    </v-btn>
  </v-form>
  
 <v-alert
     v-show="processing"
      icon="mdi-shield-lock-outline"
      prominent
      text
      type="info"
    >
      <v-progress-circular
      :width="2"
      color="blue"
      style="margin-right:10px;"
      indeterminate
    ></v-progress-circular>
    Please wait while the data is being processed...
    </v-alert>
    

    </v-card-text>

   <div style="padding-bottom:20px;margin-bottom:200px;"></div>

  </v-card>
</template>

<script>

  import Vue from 'vue';
  import AccountService from '@/services/account'

  export default {
    data () {
      return {
        vat_id_error_txt: "VAT ID not valid",
        vat_id_valid_text: "VAT ID valid",
        stripe: null, 
        vat_error: null, 
        vat_valid: false, 
        card_error: null,
        nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 50) || 'Name must be less than 50 characters',
        ],
        companyRules: [
            v => !!v || 'Company name is required',
            v => (v && v.length >= 2) || 'Name must be at least 2 characters',
        ],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        streetRules: [
            v => !!v || 'Address is required',
            v => (v && v.length >= 2) || 'Address must be at least 2 characters',
        ], 
        cityRules: [
            v => !!v || 'City is required',
            v => (v && v.length >= 2) || 'City must be at least 2 characters',
        ],     
        zipRules: [
            v => !!v || 'Zip code is required',
            v => (v && v.length >= 2) || 'Zip code must be at least 2 characters',
        ],   
        name: '',
        address: '',
        city: null,
        zip: null, 
        vatValid: false, 
        vatid: null,
        company: null, 
        terms: false,
        card: null, 
        country: 'Germany',
        account_type: 'company',
        processing: false, 
        countries: [{text:"Afghanistan"},{text:"Åland Islands"},{text:"Albania"},{text:"Algeria"},{text:"American Samoa"},{text:"Andorra"},{text:"Angola"},{text:"Anguilla"},{text:"Antarctica"},{text:"Antigua and Barbuda"},{text:"Argentina"},{text:"Armenia"},{text:"Aruba"},{text:"Australia"},{text:"Austria"},{text:"Azerbaijan"},{text:"Bahamas"},{text:"Bahrain"},{text:"Bangladesh"},{text:"Barbados"},{text:"Belarus"},{text:"Belgium"},{text:"Belize"},{text:"Benin"},{text:"Bermuda"},{text:"Bhutan"},{text:"Bolivia (Plurinational State of)"},{text:"Bonaire, Sint Eustatius and Saba"},{text:"Bosnia and Herzegovina"},{text:"Botswana"},{text:"Bouvet Island"},{text:"Brazil"},{text:"British Indian Ocean Territory"},{text:"United States Minor Outlying Islands"},{text:"Virgin Islands (British)"},{text:"Virgin Islands (U.S.)"},{text:"Brunei Darussalam"},{text:"Bulgaria"},{text:"Burkina Faso"},{text:"Burundi"},{text:"Cambodia"},{text:"Cameroon"},{text:"Canada"},{text:"Cabo Verde"},{text:"Cayman Islands"},{text:"Central African Republic"},{text:"Chad"},{text:"Chile"},{text:"China"},{text:"Christmas Island"},{text:"Cocos (Keeling) Islands"},{text:"Colombia"},{text:"Comoros"},{text:"Congo"},{text:"Congo (Democratic Republic of the)"},{text:"Cook Islands"},{text:"Costa Rica"},{text:"Croatia"},{text:"Cuba"},{text:"Curaçao"},{text:"Cyprus"},{text:"Czech Republic"},{text:"Denmark"},{text:"Djibouti"},{text:"Dominica"},{text:"Dominican Republic"},{text:"Ecuador"},{text:"Egypt"},{text:"El Salvador"},{text:"Equatorial Guinea"},{text:"Eritrea"},{text:"Estonia"},{text:"Ethiopia"},{text:"Falkland Islands (Malvinas)"},{text:"Faroe Islands"},{text:"Fiji"},{text:"Finland"},{text:"France"},{text:"French Guiana"},{text:"French Polynesia"},{text:"French Southern Territories"},{text:"Gabon"},{text:"Gambia"},{text:"Georgia"},{text:"Germany"},{text:"Ghana"},{text:"Gibraltar"},{text:"Greece"},{text:"Greenland"},{text:"Grenada"},{text:"Guadeloupe"},{text:"Guam"},{text:"Guatemala"},{text:"Guernsey"},{text:"Guinea"},{text:"Guinea-Bissau"},{text:"Guyana"},{text:"Haiti"},{text:"Heard Island and McDonald Islands"},{text:"Holy See"},{text:"Honduras"},{text:"Hong Kong"},{text:"Hungary"},{text:"Iceland"},{text:"India"},{text:"Indonesia"},{text:"Côte d'Ivoire"},{text:"Iran (Islamic Republic of)"},{text:"Iraq"},{text:"Ireland"},{text:"Isle of Man"},{text:"Israel"},{text:"Italy"},{text:"Jamaica"},{text:"Japan"},{text:"Jersey"},{text:"Jordan"},{text:"Kazakhstan"},{text:"Kenya"},{text:"Kiribati"},{text:"Kuwait"},{text:"Kyrgyzstan"},{text:"Lao People's Democratic Republic"},{text:"Latvia"},{text:"Lebanon"},{text:"Lesotho"},{text:"Liberia"},{text:"Libya"},{text:"Liechtenstein"},{text:"Lithuania"},{text:"Luxembourg"},{text:"Macao"},{text:"Macedonia (the former Yugoslav Republic of)"},{text:"Madagascar"},{text:"Malawi"},{text:"Malaysia"},{text:"Maldives"},{text:"Mali"},{text:"Malta"},{text:"Marshall Islands"},{text:"Martinique"},{text:"Mauritania"},{text:"Mauritius"},{text:"Mayotte"},{text:"Mexico"},{text:"Micronesia (Federated States of)"},{text:"Moldova (Republic of)"},{text:"Monaco"},{text:"Mongolia"},{text:"Montenegro"},{text:"Montserrat"},{text:"Morocco"},{text:"Mozambique"},{text:"Myanmar"},{text:"Namibia"},{text:"Nauru"},{text:"Nepal"},{text:"Netherlands"},{text:"New Caledonia"},{text:"New Zealand"},{text:"Nicaragua"},{text:"Niger"},{text:"Nigeria"},{text:"Niue"},{text:"Norfolk Island"},{text:"Korea (Democratic People's Republic of)"},{text:"Northern Mariana Islands"},{text:"Norway"},{text:"Oman"},{text:"Pakistan"},{text:"Palau"},{text:"Palestine, State of"},{text:"Panama"},{text:"Papua New Guinea"},{text:"Paraguay"},{text:"Peru"},{text:"Philippines"},{text:"Pitcairn"},{text:"Poland"},{text:"Portugal"},{text:"Puerto Rico"},{text:"Qatar"},{text:"Republic of Kosovo"},{text:"Réunion"},{text:"Romania"},{text:"Russian Federation"},{text:"Rwanda"},{text:"Saint Barthélemy"},{text:"Saint Helena, Ascension and Tristan da Cunha"},{text:"Saint Kitts and Nevis"},{text:"Saint Lucia"},{text:"Saint Martin (French part)"},{text:"Saint Pierre and Miquelon"},{text:"Saint Vincent and the Grenadines"},{text:"Samoa"},{text:"San Marino"},{text:"Sao Tome and Principe"},{text:"Saudi Arabia"},{text:"Senegal"},{text:"Serbia"},{text:"Seychelles"},{text:"Sierra Leone"},{text:"Singapore"},{text:"Sint Maarten (Dutch part)"},{text:"Slovakia"},{text:"Slovenia"},{text:"Solomon Islands"},{text:"Somalia"},{text:"South Africa"},{text:"South Georgia and the South Sandwich Islands"},{text:"Korea (Republic of)"},{text:"South Sudan"},{text:"Spain"},{text:"Sri Lanka"},{text:"Sudan"},{text:"Suriname"},{text:"Svalbard and Jan Mayen"},{text:"Swaziland"},{text:"Sweden"},{text:"Switzerland"},{text:"Syrian Arab Republic"},{text:"Taiwan"},{text:"Tajikistan"},{text:"Tanzania, United Republic of"},{text:"Thailand"},{text:"Timor-Leste"},{text:"Togo"},{text:"Tokelau"},{text:"Tonga"},{text:"Trinidad and Tobago"},{text:"Tunisia"},{text:"Turkey"},{text:"Turkmenistan"},{text:"Turks and Caicos Islands"},{text:"Tuvalu"},{text:"Uganda"},{text:"Ukraine"},{text:"United Arab Emirates"},{text:"United Kingdom of Great Britain and Northern Ireland"},{text:"United States of America"},{text:"Uruguay"},{text:"Uzbekistan"},{text:"Vanuatu"},{text:"Venezuela (Bolivarian Republic of)"},{text:"Viet Nam"},{text:"Wallis and Futuna"},{text:"Western Sahara"},{text:"Yemen"},{text:"Zambia"},{text:"Zimbabwe"}]
      }
    }, 
    methods: {
      checkVatId() {
        if (this.vatid && this.vatid.length > 10) {
            this.vat_error = null
            AccountService.vat_check(this.$store.state.subdomain, this.vatid).then((response) => {
                //console.log(response)
                if (!response.data.valid) {
                   this.vat_valid = false
                   this.vat_error = this.vat_id_error_txt

                }
                else {
                    this.vat_valid = true
                }

                return 
            }) 
        }
        else {
            this.vat_valid  = false
            this.vat_error = this.vat_id_error_txt
        }
      },
      validate () {

        let ref = this

        let form_data = {
            subdomain: ref.$store.state.subdomain,
            email: this.email,
            name: this.name,
            address: this.address,
            company: this.company,
            zip: this.zip,
            city:  this.city,           
            account_type: this.account_type, 
            country:  this.country, 
            account_id: this.$store.state.account_id,
            cus_id: this.$store.state.cus_id,
            price_id: this.price_id,
            vat_required: this.$store.state.calculated_price,
            tax_rate: this.$store.state.calculated_price,
        }

        if (this.vatid) {
            form_data.vatid = this.vatid
        }
                
        this.processing = false

        if (this.$refs.form.validate()) {
            if (!this.vat_needed || this.vat_valid) {
                this.stripe.createSource(this.card).then(function(result) {
                    if (!result.error) {
                        ref.processing = true
                        AccountService.create_customer(form_data).then((result) => {
                            console.log("create_customer:result", result)
                            if (result.id) {
                                ref.createPaymentMethod(result.id)
                            }
                            else {
                                ref.processing = false
                            }
                        })                       
                    }
                })
            }
            else {
                if (this.vat_needed) {
                    this.vat_error = this.vat_id_error_txt
                }
            }
        }    
        else {
            if (this.vat_needed && !this.vat_valid) {
                this.vat_error = this.vat_id_error_txt
            }
        }   
      },
      createPaymentMethod(customer_id) {
        //const params = new URLSearchParams(document.location.search.substring(1));
        //const customerId = params.get('customerId');
        
        // Set up payment method for recurring usage
        //let billingName = document.querySelector('#name').value;

        //let priceId = document.getElementById('priceId').innerHTML.toUpperCase();

        this.stripe
            .createPaymentMethod({
                type: 'card',
                card: this.card,
                billing_details: {
                    address: {
                        city: this.city,
                        line1: this.address,
                        postal_code: this.zip
                    },
                    name: this.name,
                    email: this.email
                },
            })
            .then((result) => {

                if (result.error) {
                    this.displayError(result);
                } else {
                    //console.log("createPaymentMethod", result, customer_id)  
                    this.createSubscription({
                        customerId: customer_id,
                        paymentMethodId: result.paymentMethod.id,
                        priceId: this.price_id,
                        vatRequired: this.$store.state.calculated_price.vat_required,
                        taxRate: this.$store.state.calculated_price.tax_rate,
                        coupon: (this.$store.state.calculated_price.coupon_entry) ? this.$store.state.coupon : null
                    });

                    /*
                    if (isPaymentRetry) {
                    // Update the payment method and retry invoice payment
                    retryInvoiceWithNewPaymentMethod({
                        customerId: customerId,
                        paymentMethodId: result.paymentMethod.id,
                        invoiceId: invoiceId,
                        priceId: priceId,
                    });
                    
                    } else {
                    // Create the subscription
                    
                    this.createSubscription({
                        customerId: customerId,
                        paymentMethodId: result.paymentMethod.id,
                        priceId: priceId,
                    });
                    }
                    */
                }
            });
      },
      cancel () {
        this.$refs.form.reset()
        window.location = this.$store.state.cancel_url
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      getConfig() {
        return fetch(Vue.prototype.$apiBase+'/stripe/config', {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subdomain: this.$store.state.subdomain
            }),
            })
            .then((response) => {
            return response.json();
            })
            .then((response) => {
             // Set up Stripe Elements
             this.stripeElements(response.publishableKey);
             this.checkVatId()
            });
      },
      stripeElements(publishableKey) {
        this.stripe = window.Stripe(publishableKey);

        let ref = this

        if (document.getElementById('card-element')) {
            let elements = this.stripe.elements();

            // Card Element styles
            let style = {
                base: {
                    fontSize: '16px',
                    color: '#32325d',
                    fontFamily:
                    'Roboto, sans-serif',
                    fontSmoothing: 'antialiased',
                    '::placeholder': {
                    color: '#6666666',
                    },
                },
            };

            this.card = elements.create('card', { style: style });
            this.card.mount('#card-element');
           
            this.card.on('change', function (event) {
                ref.displayError(event);
            });
        }
      },
      changeCountry() {
        this.$store.state.user_country = this.country
        this.$emit('recalculate', {});
      },
      changeAccountType() {
        this.$store.state.user_account_type = this.account_type
        this.$emit('recalculate', {});
      },
      displayError(event) {
        if (event.error) {
            this.card_error = event.error.message;
            this.processing = false
        } else {
            this.card_error =null
        }
      },
      createSubscription({ customerId, paymentMethodId, priceId, vatRequired, taxRate, coupon }) {

        return (
            fetch(Vue.prototype.$apiBase+'/stripe/create-subscription', {
            method: 'post',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                subdomain: this.$store.state.subdomain,
                customerId: customerId,
                paymentMethodId: paymentMethodId,
                priceId: priceId,
                accountType: this.account_type,
                country: this.country,
                vatRequired: vatRequired,
                taxRate: taxRate,
                coupon: coupon, 
            }),
            })
            .then((response) => {
                return response.json();
            })
            // If the card is declined, display an error to the user.
            .then((result) => {
                if (result.error) {
                    // The card had an error when trying to attach it to a customer
                    throw result;
                }
                return result;
            })
            // Normalize the result to contain the object returned
            // by Stripe. Add the addional details we need.
            .then((result) => {
                return {
                // Use the Stripe 'object' property on the
                // returned result to understand what object is returned.
                    subscription: result,
                    paymentMethodId: paymentMethodId,
                    priceId: priceId,
                };
            })
            // Some payment methods require a customer to do additional
            // authentication with their financial institution.
            // Eg: 2FA for cards.
            .then(this.handlePaymentThatRequiresCustomerAction)
            // If attaching this card to a Customer object succeeds,
            // but attempts to charge the customer fail. You will
            // get a requires_payment_method error.
            .then(this.handleRequiresPaymentMethod)
            // No more actions required. Provision your service for the user.
            .then(this.onSubscriptionComplete)
            .catch((error) => {
                // An error has happened. Display the failure to the user here.
                // We utilize the HTML element we created.
                this.displayError(error);
            })
        );
      },
      retryInvoiceWithNewPaymentMethod({
        customerId,
        paymentMethodId,
        invoiceId,
        priceId,
        }) {
        return (
            fetch('/stripe/retry-invoice', {
            method: 'post',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                subdomain: this.$store.state.subdomain,
                customerId: customerId,
                paymentMethodId: paymentMethodId,
                invoiceId: invoiceId,
            }),
            })
            .then((response) => {
                return response.json();
            })
            // If the card is declined, display an error to the user.
            .then((result) => {
                if (result.error) {
                // The card had an error when trying to attach it to a customer
                throw result;
                }
                return result;
            })
            // Normalize the result to contain the object returned
            // by Stripe. Add the addional details we need.
            .then((result) => {
                return {
                // Use the Stripe 'object' property on the
                // returned result to understand what object is returned.
                invoice: result,
                paymentMethodId: paymentMethodId,
                priceId: priceId,
                isRetry: true,
                };
            })
            // Some payment methods require a customer to be on session
            // to complete the payment process. Check the status of the
            // payment intent to handle these actions.
            .then(this.handlePaymentThatRequiresCustomerAction)
            // No more actions required. Provision your service for the user.
            .then(this.onSubscriptionComplete)
            .catch((error) => {
                // An error has happened. Display the failure to the user here.
                // We utilize the HTML element we created.
                this.displayError(error);
            })
        );
      },
      handlePaymentThatRequiresCustomerAction({
            subscription,
            invoice,
            priceId,
            paymentMethodId,
            isRetry,
        }) {

            console.log("handlePaymentThatRequiresCustomerAction")
        if (subscription && subscription.status === 'active') {
            // subscription is active, no customer actions required.
            return { subscription, priceId, paymentMethodId };
        }


        // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
        // If it's a retry, the payment intent will be on the invoice itself.
        let paymentIntent = invoice
            ? invoice.payment_intent
            : subscription.latest_invoice.payment_intent;

        if (
            paymentIntent.status === 'requires_action' ||
            (isRetry === true && paymentIntent.status === 'requires_payment_method')
        ) {
            return this.stripe
            .confirmCardPayment(paymentIntent.client_secret, {
                payment_method: paymentMethodId,
            })
            .then((result) => {
                if (result.error) {
                // start code flow to handle updating the payment details
                // Display error message in your UI.
                // The card was declined (i.e. insufficient funds, card has expired, etc)
                throw result;
                } else {
                if (result.paymentIntent.status === 'succeeded') {
                    // There's a risk of the customer closing the window before callback
                    // execution. To handle this case, set up a webhook endpoint and
                    // listen to invoice.paid. This webhook endpoint returns an Invoice.
                    return {  
                        priceId: priceId,
                        subscription: subscription,
                        invoice: invoice,
                        paymentMethodId: paymentMethodId,
                    };
                }
                }
            });
        } else {
            // No customer action needed
            return { subscription, priceId, paymentMethodId };
        }
      },
      handleRequiresPaymentMethod({
        subscription,
        paymentMethodId,
        priceId,
        }) {
        if (subscription.status === 'active') {
            // subscription is active, no customer actions required.
            return { subscription, priceId, paymentMethodId };
        } else if (
            subscription.latest_invoice.payment_intent.status === 'requires_payment_method'
        ) {
            // Using localStorage to store the state of the retry here
            // (feel free to replace with what you prefer)
            // Store the latest invoice ID and status
            localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
            localStorage.setItem('latestInvoicePaymentIntentStatus', subscription.latest_invoice.payment_intent.status);
            throw { error: { message: 'Your card was declined.' } };
        } else {
            return { subscription, priceId, paymentMethodId };
        }
      },
      onSubscriptionComplete(result) {
        console.log("____onSubscriptionComplete");
        // Payment was successful. Provision access to your service.
        // Remove invoice from localstorage because payment is now complete.
        this.clearCache();
        // Call your backend to grant access to your service based on
        // the product your customer subscribed to.
        // Get the product by using result.subscription.price.product

        if (result.subscription && result.subscription.customer) {
          //  window.location = this.$store.state.success_url
          AccountService.webapp_callback ({
              cus_id: result.subscription.customer, 
              account_id: this.$store.state.account_id,
              subdomain: this.$store.state.subdomain, 
              event_type: "subscription_complete", 
              data: {
                  subscription: result.subscription,
                  plan_uid: this.$store.state.plan_uid, 
              }
          }).then( () => {

              let s_url = this.$store.state.success_url 
              setTimeout(function(){ 
                  window.location = s_url
              }, 3000);
             
          })
        }

      },
      clearCache() {
        localStorage.clear();
      }
    },
    computed: {
        subdomain() {
            return this.$store.state.subdomain
        },
        cus_data() {
            return this.$store.state.cus_data
        },
        cus_exists() {
            return this.$store.state.cus_exists
        },
        price_id() {
            if (this.$store.state.calculated_price) {
                return this.$store.state.calculated_price.price_id
            } 
            return null           
        },
        vat_needed() {
            if (this.account_type == 'private') {
                return false
            }
            if (this.$store.state.calculated_price) {
                return this.$store.state.calculated_price.vat_required
            }
            return false 
        },

        rules () {
        const rules = []

        if (this.max) {
            const rule =
            v => (v || '').length <= this.max ||
                `A maximum of ${this.max} characters is allowed`

            rules.push(rule)
        }

        if (!this.allowSpaces) {
            const rule =
            v => (v || '').indexOf(' ') < 0 ||
                'No spaces are allowed'

            rules.push(rule)
        }

        if (this.match) {
            const rule =
            v => (!!v && v) === this.match ||
                'Values do not match'

            rules.push(rule)
        }

        return rules
        },
    },
    mounted: function () {


        if (this.cus_data.address) {
            if (this.cus_data.address.line1) {
                this.address = this.cus_data.address.line1
            }

            if (this.cus_data.address.line2) {
                this.company = this.cus_data.address.line2
            }

            if (this.cus_data.address.line2) {
                this.company = this.cus_data.address.line2
            }

            if (this.cus_data.address.postal_code) {
                this.zip = this.cus_data.address.postal_code
            }

            if (this.cus_data.address.city) {
                this.city = this.cus_data.address.city
            }
        }

        this.email = this.$store.state.email

        if (this.cus_data.name) {
            this.name = this.cus_data.name
        }
        
        if (this.cus_data.metadata) {
           
            if (this.cus_data.metadata.vat_id) {
                this.vatid = this.cus_data.metadata.vat_id
            }
            if (this.cus_data.metadata.account_type) {
                this.account_type = this.cus_data.metadata.account_type
            }
            if (this.cus_data.metadata.country) {
                this.country = this.cus_data.metadata.country
            }
       
        }

        this.getConfig()
   
    }
  }
</script>

<style scoped>
    .card-container {
        /*
        background-color:rgba(0, 0, 0, 0.05);
        padding:20px 10px 20px 10px;
        border-radius:5px;
        -webkit-box-shadow: 10px 10px 24px -6px rgba(0,0,0,0.11);
        -moz-box-shadow: 10px 10px 24px -6px rgba(0,0,0,0.11);
        box-shadow: 10px 10px 24px -6px rgba(0,0,0,0.11);
        */
    }

    a {
        color: #4caf50 !important; 
    }

    a:hover {
        font-weight: bold;
    }


/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

</style>